import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import DisaggregateMetricCard from "../DisaggregateMetricCard";
import SimpleDonutChart from "../charts/SimpleDonutChart";
import SoloIcon from "../SoloIcon";
import BannerRibbon from "../BannerRibbon";

const EducationMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const educationOrders = getMetricGroupOrderIds(tab);

    const sortedEducationMetrics = educationOrders.map((order: number[]) => 
        categorizedData.Education
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('Education metrics:', sortedEducationMetrics)

    const education: DisaggregatedMetric[] = sortedEducationMetrics[0];

    const bachelors = indicators.find(metric => metric.id === 220);
    const ged = indicators.find(metric => metric.id === 219);
    const nohs = indicators.find(metric => metric.id === 222);

    let metricsForTab = indicators; // Get metrics for the current tab

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }


    return (
        <>
            <div className="mb-2">
                <BannerRibbon text="Education Indicators" color="#225591"/>
            </div>   
            <p className="text-port-text mx-4 text-[10px] mb-4">Data updates published July 15, 2025. Data testing in progress.</p>
            <div className="grid grid-cols-2 gap-4 place-items-start ml-4">
                {education.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}

                <div className="col-span-2 w-full pr-4">
                    <div className="bg-anti-flash pb-2">
                        <DisaggregateMetricCard
                            key={220}
                            id={220}
                            metric={indicators.find(indicator => indicator.id === 220) || null}
                            title={"Educational Attainment"}
                            svg={undefined}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            showMetadataIcon={false}
                            showValue={false}
                        />
                        <div className="flex items-start justify-center gap-2">
                            {bachelors && 
                            <div className="flex flex-col items-start">
                                <SoloIcon
                                    key={bachelors.id}
                                    id={bachelors.id}
                                    svg={undefined}
                                    disaggData={indicators}
                                    geoDetails={geoDetails}
                                    geoTag={geoTag}
                                    selectionActive={selectionActive}
                                    margin="ml-20"
                                />
                                <SimpleDonutChart indicators={indicators} id={bachelors.id} fillColor="#00A18A" remainColor="#D5D5D5" valueColor="#4D4D4D"/>
                                <p className="text-port-text text-xs font-bold mt-2 max-w-28">{bachelors.name}</p>
                            </div>
                            }

                            {ged && 
                            <div className="flex flex-col items-start">
                                <SoloIcon
                                    key={ged.id}
                                    id={ged.id}
                                    svg={undefined}
                                    disaggData={indicators}
                                    geoDetails={geoDetails}
                                    geoTag={geoTag}
                                    selectionActive={selectionActive}
                                    margin="ml-20"
                                />
                                <SimpleDonutChart indicators={indicators} id={ged.id} fillColor="#00A18A" remainColor="#D5D5D5" valueColor="#4D4D4D"/>
                                <p className="text-port-text text-xs font-bold mt-2 max-w-28">{ged.name}</p>
                            </div>
                            }
                            
                            {nohs && 
                            <div className="flex flex-col items-start">
                                <SoloIcon
                                    key={nohs.id}
                                    id={nohs.id}
                                    svg={undefined}
                                    disaggData={indicators}
                                    geoDetails={geoDetails}
                                    geoTag={geoTag}
                                    selectionActive={selectionActive}
                                    margin="ml-20"
                                />
                                <SimpleDonutChart indicators={indicators} id={nohs.id} fillColor="#00A18A" remainColor="#D5D5D5" valueColor="#4D4D4D"/>
                                <p className="text-port-text text-xs font-bold mt-2 max-w-28">{nohs.name}</p>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EducationMetrics;